<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    Select Asset{{ data['multiple'] ? 's' : '' }}
    <span>
      ({{ dataSource.selection.selected.length }})
    </span>
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-2 my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <button mat-raised-button class="mr-2 mr-lg-3 my-1" type="button" (click)="onFilter()">
      <mat-icon>filter_list</mat-icon> Filter
    </button>

    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search"/>

    <button
      mat-raised-button
      color="secondary"
      class="mr-2 mr-lg-3 my-1"
      type="submit"
      matTooltip="Run the current search">
      <mat-icon>search</mat-icon> Search
    </button>

    <button
      mat-raised-button
      type="button"
      class="mr-2 my-1"
      (click)="onClearSelected()">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="id"
    matSortDirection="asc"
    matSortDisableClear >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)"
          appMarginRight>
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="thumbnail">
      <th mat-header-cell *matHeaderCellDef>Thumbnail</th>
      <td mat-cell *matCellDef="let asset" class="text-wrap">
        <img class="rounded-0 p-1" style="cursor: pointer; max-width: 100px; max-height: 50px;" (click)="onOpenUrl(asset.main_image_url)" [src]="asset.thumbnail_image_url" [alt]="asset.name" *ngIf="asset.main_image_url && asset.thumbnail_image_url">
        <img class="rounded-0 p-1" style="cursor: pointer; max-width: 100px; max-height: 50px;" (click)="onOpenUrl(asset.main_image_url)" [alt]="asset.name" src="./assets/images/placeholder.png" *ngIf="!(asset.main_image_url && asset.thumbnail_image_url)" />
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the id of the asset.">
        #
      </th>
      <td mat-cell *matCellDef="let asset">
        {{ asset.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the name of the asset." [style.width.px]="250">
        Name
      </th>
      <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        {{ asset.name  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the code of the asset.">
        Code
      </th>
      <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        {{ asset.code  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="asset_type">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Type
      </th>
      <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        <ng-container *ngIf="asset.asset_type?.parent">
          <small style="display: block;">
            {{ (asset.asset_type?.parent?.name | ellipsis: ['30']) || '' }}
          </small>
        </ng-container>
        <mat-icon *ngIf="asset.asset_type?.parent_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
        {{ (asset.asset_type?.name | ellipsis: ['30'])  || '' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="flags">
      <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="100">
        Flags
      </th>
      <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        <mat-icon *ngIf="asset.is_visible" matTooltip="Visible on Mobile app." class="visible-yes">visibility</mat-icon>
        <mat-icon *ngIf="asset.is_mobile" matTooltip="Movable Asset." class="mobile-yes">directions_car</mat-icon>
        <mat-icon *ngIf="asset.is_safety_critical" matTooltip="Safety Critical." class="safety-critical-yes">warning</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Status
      </th>
      <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        <span [style.color]="assetsService.getStatusColor(asset.status) || null">
          {{ assetsService.getStatusLabel(asset.status) }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="owner_type">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Owner Type
      </th>
      <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        {{ assetsService.getOwnerTypeLabel(asset.owner_type) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="condition_rating">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Condition Rating
      </th>
      <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
        <span [style.color]="assetsService.getConditionColor(asset.condition_rating) || null">
          {{ assetsService.getConditionLabel(asset.condition_rating)  }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="site">
      <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the site name of the asset.">
        {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
      </th>
      <td mat-cell *matCellDef="let asset" class="text-wrap">
        <ng-container *ngIf="asset.site">
          <ng-container *ngIf="asset?.site?.parent_site">
            <small style="display: block;">
              <a [routerLink]="utils.prepareSiteRelatedLink(asset?.site?.parent_site?.id, null, '/edit/details')">
                {{ (asset?.site?.parent_site?.name | ellipsis: ['30']) || '' }}
              </a>
            </small>
          </ng-container>
          <mat-icon *ngIf="asset?.site?.parent_site_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
          <a [routerLink]="utils.prepareSiteRelatedLink(asset?.site?.id, asset?.site?.parent_site?.id, '/edit/details')">
            {{ (asset?.site?.name | ellipsis: ['30']) || '' }}
          </a>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="dataSource.selection.toggle(row.id)"></tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    class="my-2 mx-1"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSaveAndClose()"
    [disabled]="data['required'] && !dataSource.selection.hasValue()">
    Select & Close
  </button>
</mat-dialog-actions>
